(function (w) {
	'use strict';

	// TODO: seems not in used. If so - maybe it's better to remove it.

	function LazyLoad(src) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.src = '/' + src;
		var first = document.getElementsByTagName('script')[0];
		first.parentNode.insertBefore(script, first);
	}

	w.mx = w.mx || {};
	w.mx.components = w.mx.components || {};
	w.mx.components.LazyLoad = LazyLoad;

	angular.module('mx.components').directive('mxLazyLoad', function mxLazyLoadDirective() {
		return {
			restrict: 'A',
			scope: false,
		};
	});
})(window);
